import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-about-whatsapp',
  standalone: true,
  imports: [],
  templateUrl: './about-whatsapp.component.html'
})
export class AboutWhatsappComponent {
  /** Emitted when the user navigates back from the article. */
  @Output() back = new EventEmitter<void>();
}
